import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('routes', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`routes/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('routes', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.put(`routes/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`routes/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        documents: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('documents', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
